import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-section">
      <div className="about-container">
        <h1 className="about-heading">About VORTREX Bot</h1>
        <p className="about-subtext">
          VORTREX Bot is an AI-powered, wallet-based trading automation system designed for passive crypto earnings — without requiring deposits, KYC, or giving up wallet control. 
          It works 24/7, scanning the markets and executing smart trades while your assets stay secure in your own wallet.
        </p>

        <div className="about-content-grid">
          <div className="about-card">
            <h3>🌍 Our Mission</h3>
            <p>
              To make advanced trading accessible to everyone — no experience required, no exchanges needed, and no risks of handing over your funds.
            </p>
          </div>

          <div className="about-card">
            <h3>🚀 Our Vision</h3>
            <p>
              A decentralized future where anyone can grow their crypto wealth passively using AI — safely, privately, and globally.
            </p>
          </div>

          <div className="about-card">
            <h3>🛡 Built with Trust</h3>
            <p>
              VORTREX Bot operates on-chain with full transparency — no hidden permissions, no withdrawal rights, and complete control in your hands at all times.
            </p>
          </div>
        </div>

        <div className="about-bottom-quote">
          “While others trade manually, VORTREX Bot trades smartly — and you earn passively.”
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
